export default "/images/vendor/flag-icon-css/flags/1x1/ax.svg?fb29ad0e1dbf3e0eb0f0c2af374424a1";